"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const keautils_1 = require("keautils");
exports.formatNumber = keautils_1.formatNumber;
exports.formatDate = keautils_1.formatDate;
function formatHours(value) {
    if (value == null)
        return "";
    const hours = Math.floor(value);
    const minutes = Math.floor(value * 60 - (hours * 60));
    return formatInt(hours, 2) + ":" + formatInt(minutes, 2);
}
exports.formatHours = formatHours;
/**Formatea una cantidad de moneda*/
function formatCurrency(value) {
    return keautils_1.formatNumber(value, 1, 2, true, "$");
}
exports.formatCurrency = formatCurrency;
/**Formatea una cantidad con 2 dígitos decimales*/
function formatDecimal(value, digitos = 2) {
    return keautils_1.formatNumber(value, 1, digitos, true);
}
exports.formatDecimal = formatDecimal;
/**Formatea un entero poniendo cierto numero de ceros */
function formatInt(value, zeroes) {
    return keautils_1.formatNumber(value, zeroes, 0);
}
exports.formatInt = formatInt;
/**Formatea un porcentaje con 2 decimales */
function formatPercent(value) {
    if (value == null) {
        return "";
    }
    else {
        const num = typeof (value) == "string" ? parseFloat(value) : value;
        return keautils_1.formatNumber(num * 100, 0, 2) + "%";
    }
}
exports.formatPercent = formatPercent;
function toDate(value) {
    if (value == null) {
        return value;
    }
    if (typeof value == "string")
        return new Date(value);
    return value;
}
exports.toDate = toDate;
/**Quita los saltos de linea y recorta una cadena*/
function formatLongText(text, len = 60) {
    const removeLineJumps = text.replace(/\r|\n/, "");
    if (removeLineJumps.length <= len)
        return removeLineJumps;
    else
        return removeLineJumps.substr(0, len) + "...";
}
exports.formatLongText = formatLongText;
/**Pega todos los elemetnos de la lista con saltos de linea,  si la lista es de mas de maxLen elementos nos muestra al final (n elementos más) */
function formatLongList(list, maxLen = 5) {
    const items = list;
    const max = maxLen;
    if (items.length <= max) {
        return items.join("\r\n");
    }
    else {
        return items.slice(0, max).join("\r\n") + "\r\n" + "(" + (items.length - max) + " elementos mas)";
    }
}
exports.formatLongList = formatLongList;
/**Formatea una fecha considerando la fecha de hoy y escribiendo el tiempo transcurrido. Ej. Justo ahora, hace 3 minutos, hace 2 semanas, hace 1 año */
function formatDateTimeFriendly(value) {
    if (value == null)
        return "";
    const date = toDate(value);
    const now = new Date().valueOf();
    const seconds = (now - date.valueOf()) / 1000;
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365.25);
    return (seconds < 30 ? "Justo ahora" :
        seconds < 120 ? "Hace un minuto" :
            minutes < 30 ? "Hace " + minutes + " minutos" :
                minutes < 45 ? "Hace media hora" :
                    hours == 1 ? "Hace una hora" :
                        hours <= 24 ? "Hace " + hours + " horas" :
                            days < 2 ? "Ayer" :
                                days < 7 ? "Hace " + days + " dias" :
                                    weeks == 1 ? "Hace una semana" :
                                        weeks < 4 ? "Hace " + weeks + " semanas" :
                                            months == 1 ? "Hace un mes" :
                                                months < 12 ? "Hace " + months + " meses" :
                                                    years == 1 ? "Hace un año" :
                                                        "Hace " + years + " años");
}
exports.formatDateTimeFriendly = formatDateTimeFriendly;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/format.js
// module id = 501
// module chunks = 0